export const ServiceHost = 'https://service.commtknk.com/api'